"use strict";

var $ = require("jquery");

function tabReplaceHash(element) {
    let url = location.href.replace(/\/$/, "");
    let newUrl;
    const hash = element.attr("href").split('#')[1];
    if (!hash)
        return;

    if (hash == "home") {
        newUrl = url.split("#")[0];
    } else {
        newUrl = url.split("#")[0] + '#' + hash;
    }
    history.replaceState(null, null, newUrl);
}

/* --- Tabs - Deeplinking --- */

function tabDeeplink() {

    let url = location.href.replace(/\/$/, "");
    let tabGroup = $(".tab-deeplinking");

    if (location.hash && tabGroup.length) {
        let hash = url.split("#");
        hash = hash[1];
        if (hash == 'comments' || hash.startsWith("comment")) {
            hash = 'reviews';
        }

        var triggerEl = document.querySelector('a[data-bs-target="#' + hash + '"]');
        bootstrap.Tab.getOrCreateInstance(triggerEl).show();

        url = location.href.replace(/\/#/, "#");
        history.replaceState(null, null, url);
        setTimeout(() => {
            $(window).scrollTop(tabGroup.offset().top - 200);
        }, 400);
    }

    $('a[data-toggle="tab"]').on("click", function () {
        tabReplaceHash($(this));
    });
}

$(document).ready(function () {
    tabDeeplink();

    $('.woocommerce-review-link').on("click", function () {
        tabReplaceHash($(this));
        tabDeeplink();
    });

    $('.woocommerce-product-details__short-description .link').on("click", function () {
        tabReplaceHash($(this));
        tabDeeplink();
    });

    $('#comments .page-numbers').on("click", function () {
        tabReplaceHash($(this));
        tabDeeplink();
    });

    $('.menu-item a').on("click", function () {
        tabReplaceHash($(this));
        tabDeeplink();
    });
});

// Read more - push a little bit more from the top
$('.woocommerce-product-details__short-description .link').on("click", function () {
    $('html, body').animate({scrollTop: $(this.hash).offset().top - 300}, 100);
    return false;
});



// Javascript to enable link to tab

if (window.location.href.indexOf("contact") > -1) {
    var hash = location.hash.replace(/^#/, '');  // ^ means starting, meaning only match the first hash
    if (hash) {
        $(".tab-pane").removeClass("active show");
        $('.nav-tabs .nav-item').removeClass('active');
        $('.nav-tabs .nav-item[id="' + hash + '-tab"]').addClass('active');
        $('.tab-pane[id="' + hash + '"]').addClass('active show');
    }
}
